import { render, staticRenderFns } from "./PreBusinessBurden.vue?vue&type=template&id=150d7794&scoped=true&"
import script from "./PreBusinessBurden.vue?vue&type=script&lang=js&"
export * from "./PreBusinessBurden.vue?vue&type=script&lang=js&"
import style0 from "./PreBusinessBurden.vue?vue&type=style&index=0&id=150d7794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150d7794",
  null
  
)

export default component.exports